import { SortDirection } from "../../shared/entities/Sort";

export class ClientListRequest {
  constructor(public segmentid: null | number = null) {}
  page: number = 0;
  sortColumn: string = "amount";
  descending: SortDirection = SortDirection.Descending;
  text: string | null = null;
  impid: string | null = null;
  actionsentid: string | null = null;
  reason: string | null = null;
  pagesize: number = 50;
  filter: string | null = null;
}

export type ClientListRequestExport = {
  expectedRows: number;
} & Partial<ClientListRequest>;
